import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import useAPIClientHelper from "./useAPIClientHelper";

function useAuthService() {
  const { apiClientInstance } = useAPIClientHelper();

  const authenticateCompany = (companyId: number): Promise<string> => {
    return apiClientInstance(AuthEnums.AuthType.User)
      .CompanyAuthClient.Post({ companyId: companyId })
      .then((res) => res.data);
  };

  const sendResetEmail = (forgotPassword: ApiModels.ForgotPassword) => {
    return apiClientInstance(AuthEnums.AuthType.Unauthorized, { showErrors: true }).AuthClient.ForgotPassword(
      forgotPassword
    );
  };

  const resetPassword = (resetPassword: ApiModels.ResetPassword) => {
    return apiClientInstance(AuthEnums.AuthType.Unauthorized, { showErrors: true }).AuthClient.ResetPassword(
      resetPassword
    );
  };

  return {
    authenticateCompany,
    sendResetEmail,
    resetPassword,
  };
}

export default useAuthService;
